export type SearchBarCoreProps<T> = {
  collection: SearchCollection<T>;
  params: SearchParam<T>[];
  idProperty: keyof T;
  label?: React.ReactNode;
  children?: React.ReactNode;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  className?: string;
};
export type SearchBarCoreProps2<T extends {id: string}> = {
  collection: T[];
  params: SearchParam<T>[];
  label?: React.ReactNode;
  children?: React.ReactNode;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  className?: string;
};

export type SearchCollection<T> = {
  allIds: string[];
  byId: Record<string, T>;
};

type ObjectSearchParam<T> = {
  name: keyof T;
  compare: (value: string, param: T[keyof T]) => boolean;
};
export type SearchParam<T> = keyof T | ObjectSearchParam<T>;

export function isObjectSearchParam<T>(
  param: keyof T | ObjectSearchParam<T>
): param is ObjectSearchParam<T> {
  return (param as ObjectSearchParam<T>).name !== undefined;
}
